import React, { Suspense, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Container, ContainerScroll } from 'geniebook-ui/dist';
import { subjectIdFromName } from '@utils/helpers/SubjectParser';
import {
  resetToDefaultNavbarState,
  setNavbarWithTitleWithTopNavbar,
} from '@atom/navbarAtom';
import useHideBottomNavbar from '@utils/helpers/useHideBottomNavbar';
import 'src/assets/css/background.css';

const CreateWorksheet = React.lazy(() => import('geniesmart/CreateWorksheet'));

function CreateWorksheetPage() {
  useHideBottomNavbar();

  useEffect(() => {
    setNavbarWithTitleWithTopNavbar('Create Worksheet');
    setNavbarWithTitleWithTopNavbar('Create Worksheet');
    return () => {
      resetToDefaultNavbarState();
    };
  });

  const { subjectId } = useParams();
  const navigate = useNavigate();

  const onNavigate = (navigation: string) => {
    navigate(navigation);
  };
  return (
    <ContainerScroll
      customScrollBarProps={{
        className:
          "container-bg relative bg-[url('/src/assets/background/Background_Default_1.svg')] bg-primary-navyblue-dark bg-center bg-no-repeat bg-fixed bg-cover h-[calc((100*var(--vh,vh))-64px)] !h-[calc(100vh-68px)] md:px-[65px]",
      }}
    >
      <Container className={'max-lg:pt-6 lg:pt-10 max-xl:!px-5'}>
        <Suspense>
          <CreateWorksheet
            onNavigate={onNavigate}
            subjectId={subjectIdFromName(subjectId ?? '')}
            subjectName={subjectId}
          />
        </Suspense>
      </Container>
    </ContainerScroll>
  );
}

export default CreateWorksheetPage;
